import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ChevronDown, ChevronRight } from "lucide-react";
import { toast } from "sonner";

export default function RequirementTemplates() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(null);

  const load = async () => {
    try {
      const { data } = await api.get("/requirements/templates");
      setItems(data);
    } catch { toast.error("No se pudieron cargar las plantillas"); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const toggleActive = async (tpl) => {
    try {
      await api.patch(`/requirements/templates/${tpl.id}`, { active: !tpl.active });
      load();
    } catch (err) { toast.error(err.response?.data?.detail || "No se pudo actualizar"); }
  };

  if (loading) return <div className="p-8 text-center text-slate-400">Cargando…</div>;

  return (
    <div className="space-y-3" data-testid="legal-templates-tab">
      <div className="text-xs text-slate-400">
        Listas de requisitos por dependencia, programa y tipo de trámite. Se instancian como checklist en cada contrato.
      </div>
      {items.map((t) => (
        <div key={t.id} className="panel" data-testid={`tpl-card-${t.key || t.id}`}>
          <button className="w-full px-4 py-3 flex items-center justify-between text-left"
            onClick={() => setOpen(open === t.id ? null : t.id)} data-testid={`tpl-toggle-${t.key || t.id}`}>
            <div className="flex items-center gap-2">
              {open === t.id ? <ChevronDown className="w-4 h-4 text-slate-400" /> : <ChevronRight className="w-4 h-4 text-slate-400" />}
              <div>
                <div className="font-display font-bold text-slate-100 text-sm">{t.name}</div>
                <div className="text-[10px] font-mono text-slate-500 uppercase">
                  {t.dependency} · {t.program} · {t.items?.length || 0} requisitos
                  {t.system && " · PLANTILLA DEL SISTEMA"}
                </div>
              </div>
            </div>
            <span className={`text-[10px] px-2 py-0.5 rounded-sm font-mono uppercase ${t.active ? "text-green-400 bg-green-400/10" : "text-slate-400 bg-slate-500/10"}`}>
              {t.active ? "Activa" : "Inactiva"}
            </span>
          </button>
          {open === t.id && (
            <div className="px-4 pb-4 space-y-2">
              <div className="space-y-1">
                {(t.items || []).map((it) => (
                  <div key={it.number}>
                    {it.separator && (!t.items[it.number - 2] || t.items[it.number - 2].separator !== it.separator) && (
                      <div className="text-[10px] font-mono text-amber-400 uppercase tracking-widest mt-2 mb-1">➤ {it.separator}</div>
                    )}
                    <div className="flex gap-2 text-sm">
                      <span className="font-mono text-cyan-300 w-7 shrink-0 text-right">{it.number}.</span>
                      <div>
                        <span className="text-slate-200">{it.name}</span>
                        {it.conditional && <span className="ml-2 text-[10px] px-1.5 py-0.5 rounded-sm font-mono uppercase text-amber-300 bg-amber-400/10">Condicional</span>}
                        {it.description && <div className="text-xs text-slate-500">{it.description}</div>}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {t.physical_requirements && (
                <div className="panel p-3 mt-2" style={{ background: "rgba(15,23,42,0.5)" }}>
                  <div className="label-mono mb-1">// REQUISITOS FÍSICOS DEL TRÁMITE</div>
                  <div className="text-xs text-slate-300">{t.physical_requirements}</div>
                </div>
              )}
              <button data-testid={`tpl-active-toggle-${t.key || t.id}`} onClick={() => toggleActive(t)}
                className="btn-ghost px-3 py-1.5 text-xs uppercase tracking-widest mt-2">
                {t.active ? "Desactivar plantilla" : "Activar plantilla"}
              </button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
